import { AuthService } from "@/services";

export default {
  name: "password-recovery-otp",
  components: {},
  props: [],
  data() {
    return {
      otpCode: "",
      loading: false,
      repeatLoading: false,
      countdownTimer: "",
      isCounterExpired: false,
      clockInterval: "",
      rules: {
        required: value =>
          !!value ||
          this.$t("authPage.passwordRecoveryOTPPage.otpCode.validation")
        // min: v => v.length >= 8 || "Min 8 characters",
        // emailMatch: () => `The email and password you entered don't match`
      }
    };
  },
  computed: {
    otpToken() {
      return localStorage.getItem("otpToken");
    },
    emailOrMobile() {
      return localStorage.getItem("emailOrMobile");
    },
    ttl() {
      return localStorage.getItem("ttl");
    }
  },
  mounted() {
    this.countdown(this.ttl);
  },
  methods: {
    countdown(distance) {
      distance = distance / 1000;
      this.clockInterval = setInterval(() => {
        distance--;
        let minutes = Math.floor(distance / 60);
        let seconds = Math.floor(distance % 60);
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        let x = minutes + ":" + seconds;
        if (distance < 0) {
          this.countdownTimer = "00:00";
          this.isCounterExpired = true;
          clearInterval(this.clockInterval);
        } else {
          this.countdownTimer = x;
        }
      }, 1000);
    },
    verifyPasswordOpt() {
      this.loading = true;
      let otpToken = localStorage.getItem("otpToken");
      AuthService.passwordRecoveryOtp(this.otpCode, otpToken)
        .then(response => {
          localStorage.setItem("otpToken", response.data.data.otp_token);
          localStorage.removeItem("emailOrMobile");
          // this.checkIsAuth();
          this.$router.push("password-reset");
        })
        .catch(error => {
          this.$toast.error(error.response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resendOtpCode() {
      this.repeatLoading = true;
      let otpToken = localStorage.getItem("otpToken");
      AuthService.resendPasswordRecoveryOtp(otpToken)
        .then(response => {
          localStorage.setItem("otpToken", response.data.data.otp_token);
          this.countdown(response.data.data.ttl);
          this.isCounterExpired = !this.isCounterExpired;
          this.$toast.success(response.data.message);
        })
        .catch(error => {
          this.$toast.error(error.response.data.message);
        })
        .finally(() => {
          this.repeatLoading = false;
        });
    }
  }
};
